import {createContext, useEffect, useContext, useState} from "react";
import {retrieveTempUsername} from "./clients/UserClient";
const {retrieveUser} = require("./clients/UserClient");
const React = require("react");


const UserContext = createContext(null)

export const useUser = () => useContext(UserContext);

export const UserProvider = ({children}) => {
    //we also have temp users who are not logged in - so this object is {username: "rival-giraffe", isLoggedIn: false}
    const [user, setUser] = useState({});
    const [sessionId, setSessionId] = useState(sessionStorage.getItem("sessionId"))

    //Make a method that retrieves a temporary user. Also, make sure session id is always up-to-date by adding event listener
    //(not in the same method)
    const retrieveTempUser = (sessionId) => {
        retrieveTempUsername(sessionId)
            .then((user) => {setUser({username: user.username, isLoggedIn: false})})
            .catch(e => console.error("Something went wrong when retrieving temp username: ", e))
    }

    useEffect(() => {
        window.addEventListener('session-id-updated', (event) => {
            setSessionId(event.detail.sessionId);
        })
    }, []);

    useEffect(() => {

        //There is a theoretical race condition here, if the session id is updated while the below promises are being
        //resolved, and the new useEffect promises based on the new session id somehow resolve before the old promises do
        //However, this is so unlikely, and should only case a wrong temporary username until the next refresh, that we dont care.
        retrieveUser()
            .then((user) => setUser({username: user.username, isLoggedIn: true}))
            .catch(() => {
                //Retrieve temp user instead
                if(sessionId) {
                    console.log("Not logged in - retrieving temp username");
                    retrieveTempUser(sessionId)
                } else {
                    console.log("Not logged in and no session id - doing nothing")
                }
            })
    }, [sessionId]);

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}